import { Component, createRef } from "react";
import { connect } from "react-redux";
import { customerSearch, clearCustomerSearch } from "../../../redux/tiers/tiersActions";
import CustomizedTextField from "../../Input/CustomizedTextField";
import TextFieldWithTypingTimeout from "../../Input/TextFieldWithTypingTimeout";
import { clone } from "../../../utils";
import MapIcon from "@mui/icons-material/Map";
import { getNoteStatus, formatNoteStatus } from "../../../redux/siteMonitoring/siteMonitoringStatusActions";
import {
	setEditingNote,
	noteIsDisabled,
	cancelNote,
	terminateNote,
	fillIdOfPhotoAndAddCreationPhoto,
	getDefaultPhoto,
	checkIfDateDeadlineCanBeChange,
	confirmNote,
	canTerminateNote,
	canCancelNote,
	canConfirmNote,
	canRelaunchNote,
	relaunchNote,
	historizeNote,
	canHistorizeNote,
} from "../../../redux/siteMonitoring/noteActions";
import { FormControl, Icon, InputLabel } from "@mui/material";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import { MenuItem } from "@mui/material";
import PhotoFieldWithPreview from "../../Photos/PhotoFieldWithPreview";
import TableWithoutPagination from "../../Table/TableWithoutPagination";
import { throwErrorMessage } from "../../../lib/error_helper";
import { READER_ROLE } from "../../../redux/siteMonitoring/siteMonitoringConstants";
import { NO_VALUE } from "../../../constants";
import { loadPlan } from "../../../redux/siteMonitoring/planActions";
import DatePicker from "../../Input/DatePicker";
import CustomizedSelect from "../../Input/CustomizedSelect";

class DetailsTab extends Component {
	constructor(props) {
		super(props);

		this.table = createRef();

		this.state = {
			tagRows: [],
			stateRows: [],
			usersRows: [],
			tagsSelectOpen: false,
			columns: [
				{
					Header: "Photos",
					columns: [
						{
							Header: "",
							id: "actions",
							width: 50,
							Cell: this.renderButtons.bind(this),
						},
						{
							Header: "Photo",
							Cell: ({ row }) => {
								let currentPhoto = this.props.editingNote.document_ids.filter(
									(d) => !d.deleted && (d.guid || d.id)
								)[row.index];

								let noteDisabled = noteIsDisabled(
									this.props.siteMonitoring,
									this.props.editingNote,
									this.props.activeUser
								);

								if (!currentPhoto) return null;

								return (
									<div className="center col-lg-12 col-md-12 col-sm-12 col-12 row without-padding solution-table-row-padding">
										<PhotoFieldWithPreview
											onPhotoChange={this.photoChange.bind(this, row.index)}
											value={currentPhoto.file_id}
											disabled={
												(currentPhoto.file_id !== undefined &&
													currentPhoto.file_id !== null &&
													currentPhoto.file_id !== "") ||
												noteDisabled
											}
											id={"photo-" + currentPhoto.guid + "-" + currentPhoto.id}
											label={"Photo"}
										/>
									</div>
								);
							},
						},
						{
							Header: "Description",
							Cell: ({ row }) => {
								let currentPhoto = this.props.editingNote.document_ids.filter(
									(d) => !d.deleted && (d.guid || d.id)
								)[row.index];

								if (!currentPhoto) return null;

								let noteDisabled = noteIsDisabled(
									this.props.siteMonitoring,
									this.props.editingNote,
									this.props.activeUser
								);

								return (
									<div className="center col-lg-12 col-md-12 col-sm-12 col-12 row without-padding solution-table-row-padding">
										<TextFieldWithTypingTimeout
											id={"description-" + currentPhoto.guid + "-" + currentPhoto.id}
											label={"Description"}
											className="full_size"
											value={currentPhoto.name ? currentPhoto.name : ""}
											disabled={noteDisabled || !currentPhoto.creating}
											onValueChange={this.onPhotoDescriptionChange.bind(this, row.index)}
										/>
									</div>
								);
							},
						},
					],
				},
			],
		};
	}

	componentDidMount() {
		this.prepareStateSelect();
		this.prepareUsersSelect();
		this.prepareTagsSelect();
	}

	prepareStateSelect() {
		let stateRows = [];

		let status = getNoteStatus(this.props.editingNote.creating);

		for (let i = 0; i < status.length; i++) {
			let currentRow = status[i];

			stateRows.push(
				<MenuItem key={i} value={currentRow}>
					{formatNoteStatus(currentRow)}
				</MenuItem>
			);
		}

		this.setState({
			stateRows,
		});
	}

	prepareUsersSelect() {
		let rows = [];

		let usersAndRights = this.props.siteMonitoring.site_supervision_authorized_user_ids.filter(
			(u) => !u.deleted && u.id && u.rights !== READER_ROLE
		);

		for (let i = 0; i < usersAndRights.length; i++) {
			let currentUser = usersAndRights[i].user_id;

			rows.push(
				<MenuItem key={currentUser.id} value={currentUser.id}>
					{currentUser.name}
				</MenuItem>
			);
		}

		this.setState({
			usersRows: rows,
		});
	}

	prepareTagsSelect() {
		let rows = [
			<MenuItem key={NO_VALUE} value={NO_VALUE} className="without-padding">
				<Button
					className="col-lg-12 col-md-12 col-sm-12 col-12 without-padding"
					onClick={this.closeSelect.bind(this)}
				>
					<Icon className="green-icon">check</Icon>
				</Button>
			</MenuItem>,
		];

		let tags = this.props.siteMonitoring.allowed_category_ids.sort((a, b) => a.name.localeCompare(b.name));

		for (let i = 0; i < tags.length; i++) {
			let currentRow = tags[i];

			rows.push(
				<MenuItem key={i} value={currentRow.id}>
					{currentRow.name}
				</MenuItem>
			);
		}

		this.setState({
			tagRows: rows,
		});
	}

	removeFromArray(arr) {
		var what,
			a = arguments,
			L = a.length,
			ax;
		while (L > 1 && arr.length) {
			what = a[--L];
			while ((ax = arr.indexOf(what)) !== -1) {
				arr.splice(ax, 1);
			}
		}
		return arr;
	}

	onAffectedUsersChange(e) {
		let newEditingNote = clone(this.props.editingNote);
		newEditingNote.assigned_user_id = e.target.value;
		this.props.setEditingNote(newEditingNote);
	}

	onDescriptionChange(value) {
		let newEditingNote = clone(this.props.editingNote);
		newEditingNote.description = value;
		this.props.setEditingNote(newEditingNote);
	}

	onNameChange(value) {
		let newEditingNote = clone(this.props.editingNote);
		newEditingNote.name = value;
		this.props.setEditingNote(newEditingNote);
	}

	onUpdateLimitDate(newValue) {
		let newEditingNote = clone(this.props.editingNote);
		newEditingNote.date_deadline = newValue;
		this.props.setEditingNote(newEditingNote);
	}

	onStatusChange(e) {
		let newEditingNote = clone(this.props.editingNote);
		newEditingNote.state = e.target.value;
		this.props.setEditingNote(newEditingNote);
	}

	onTagsChange(e) {
		let newEditingNote = clone(this.props.editingNote);
		newEditingNote.category_ids = this.removeFromArray(e.target.value, NO_VALUE);
		this.props.setEditingNote(newEditingNote);
	}

	onLotChange(e) {
		let newEditingNote = clone(this.props.editingNote);
		newEditingNote.lot_id = e.target.value;
		this.props.setEditingNote(newEditingNote);
	}

	photoChange(rowIndex, value) {
		let newEditingNote = clone(this.props.editingNote);
		let displayedPhotos = [...newEditingNote.document_ids.filter((d) => !d.deleted)];

		if (!displayedPhotos[rowIndex]) return;

		let photoToUpdateFromDisplayedPhotos = displayedPhotos[rowIndex];

		let allPhotos = [...newEditingNote.document_ids];
		let photoToUpdate = allPhotos.find(
			(p) =>
				(p.guid && p.guid === photoToUpdateFromDisplayedPhotos.guid) ||
				(p.id && p.id === photoToUpdateFromDisplayedPhotos.id)
		);

		photoToUpdate.file_id = value;
		newEditingNote.document_ids = allPhotos;
		this.props.setEditingNote(newEditingNote);
	}

	onPhotoDescriptionChange(rowIndex, value) {
		let newEditingNote = clone(this.props.editingNote);
		let displayedPhotos = [...newEditingNote.document_ids.filter((d) => !d.deleted)];

		if (!displayedPhotos[rowIndex]) return;

		let photoToUpdateFromDisplayedPhotos = displayedPhotos[rowIndex];

		let allPhotos = [...newEditingNote.document_ids];
		let photoToUpdate = allPhotos.find(
			(p) =>
				(p.guid && p.guid === photoToUpdateFromDisplayedPhotos.guid) ||
				(p.id && p.id === photoToUpdateFromDisplayedPhotos.id)
		);

		photoToUpdate.name = value;
		newEditingNote.document_ids = allPhotos;
		this.props.setEditingNote(newEditingNote);
	}

	cancelNote() {
		this.props.cancelNote(
			this.props.editingNote,
			this.props.siteMonitoring,
			this.props.notesFilters,
			this.props.activeUser
		);
	}

	terminateNote() {
		this.props.terminateNote(
			this.props.editingNote,
			this.props.siteMonitoring,
			this.props.notesFilters,
			this.props.activeUser
		);
	}

	confirmNote() {
		this.props.confirmNote(
			this.props.editingNote,
			this.props.siteMonitoring,
			this.props.notesFilters,
			this.props.activeUser
		);
	}

	relaunchNote() {
		this.props.relaunchNote(
			this.props.editingNote,
			this.props.siteMonitoring,
			this.props.notesFilters,
			this.props.activeUser
		);
	}

	historizeNote() {
		this.props.historizeNote(
			this.props.editingNote,
			this.props.siteMonitoring,
			this.props.notesFilters,
			this.props.activeUser
		);
	}

	addPhoto(element) {
		let newEditingNote = clone(this.props.editingNote);
		let photos = [...newEditingNote.document_ids.filter((d) => !d.deleted)];

		if (!photos[element.row.index]) return;

		if (photos[element.row.index - 1] && !photos[element.row.index - 1].file_id) {
			this.props.throwErrorMessage({
				title: "Information",
				message: "Photo non renseignée pour la ligne précédente",
			});

			return;
		}

		let allPhotos = [...newEditingNote.document_ids];
		allPhotos = fillIdOfPhotoAndAddCreationPhoto(allPhotos);
		newEditingNote.document_ids = allPhotos;
		this.props.setEditingNote(newEditingNote);
	}

	removePhoto(elementToDelete) {
		let newEditingNote = clone(this.props.editingNote);
		let displayedPhotos = [...newEditingNote.document_ids.filter((d) => !d.deleted)];

		let indexOfPhotoToDelete = elementToDelete.row.index;

		if (indexOfPhotoToDelete !== undefined && indexOfPhotoToDelete >= 0) {
			let photoToDeleteFromDisplayedPhotos = displayedPhotos[indexOfPhotoToDelete];

			let allPhotos = [...newEditingNote.document_ids];
			let photoToDelete = allPhotos.find(
				(p) =>
					(p.guid && p.guid === photoToDeleteFromDisplayedPhotos.guid) ||
					(p.id && p.id === photoToDeleteFromDisplayedPhotos.id)
			);
			photoToDelete.deleted = true;

			let indexOfCreationLine = allPhotos.find(function (element) {
				return !element.guid && !element.id;
			});

			if (!indexOfCreationLine) {
				allPhotos.push(getDefaultPhoto());
			}

			newEditingNote.document_ids = allPhotos;
			this.props.setEditingNote(newEditingNote);
		}
	}

	closeSelect() {
		this.setState({ tagsSelectOpen: false });
	}

	openSelect() {
		this.setState({ tagsSelectOpen: true });
	}

	onPlanClick() {
		this.props.loadPlan(this.props.editingNote.plan);
	}

	renderButtons(row) {
		let noteDisabled = noteIsDisabled(this.props.siteMonitoring, this.props.editingNote, this.props.activeUser);

		if (row.row.original.deleted) return null;

		if (!row.row.original.guid && !row.row.original.id)
			return (
				<div>
					<Button
						disabled={noteDisabled}
						onClick={this.addPhoto.bind(this, row)}
						className="col-lg-12 col-md-12 col-sm-12 col-12 small-btn without-padding without-side-margin"
						color="primary"
					>
						<Icon className="small-icon">add</Icon>
					</Button>
				</div>
			);

		return (
			<div className="solution-table-row-padding">
				<Button
					disabled={noteDisabled}
					onClick={this.removePhoto.bind(this, row)}
					className="col-lg-12 col-md-12 col-sm-12 col-12 small-btn without-padding without-side-margin"
					color="primary"
				>
					<Icon className="small-icon">delete</Icon>
				</Button>
			</div>
		);
	}

	render() {
		if (!this.props.editingNote) return null;

		let lotRows = [];
		const availableLots = this.props.lots.filter((l) => l.name);
		let noteDisabled = noteIsDisabled(this.props.siteMonitoring, this.props.editingNote, this.props.activeUser);
		let canUpdateDateDeadline = checkIfDateDeadlineCanBeChange(
			this.props.siteMonitoring,
			this.props.editingNote,
			this.props.activeUser
		);

		for (let i = 0; i < availableLots.length; i++) {
			let currentRow = availableLots[i];

			lotRows.push(
				<MenuItem key={i} value={currentRow.id}>
					{currentRow.name}
				</MenuItem>
			);
		}

		return (
			<div>
				<div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
					<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
						<TextFieldWithTypingTimeout
							id="label"
							label={"Libellé"}
							className="full_size"
							disabled={noteDisabled}
							value={this.props.editingNote.name}
							onValueChange={this.onNameChange.bind(this)}
						/>
					</div>
					<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
						<TextFieldWithTypingTimeout
							id="description"
							label={"Description"}
							className="full_size"
							multiline
							disabled={noteDisabled}
							value={this.props.editingNote.description}
							onValueChange={this.onDescriptionChange.bind(this)}
						/>
					</div>
					<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
						<FormControl className="row">
							<InputLabel id="affected-label">Affecté à</InputLabel>
							<CustomizedSelect
								labelId="affected-label"
								id="affected"
								label={"Affecté à"}
								placeholder={"Affecté à"}
								className="full_size"
								disabled={noteDisabled}
								onChange={this.onAffectedUsersChange.bind(this)}
								value={
									this.state.usersRows.length > 0 && this.props.editingNote.assigned_user_id
										? this.props.editingNote.assigned_user_id
										: ""
								}
							>
								{this.state.usersRows}
							</CustomizedSelect>
						</FormControl>
					</div>
					<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
						<FormControl className="row">
							<InputLabel id="lot-label">Lot</InputLabel>
							<CustomizedSelect
								labelId="lot-label"
								id="lot"
								label={"Lot"}
								placeholder={"Lot"}
								className="full_size"
								disabled={noteDisabled}
								onChange={this.onLotChange.bind(this)}
								value={
									lotRows.length > 0 && this.props.editingNote.lot_id
										? this.props.editingNote.lot_id
										: ""
								}
							>
								{lotRows}
							</CustomizedSelect>
						</FormControl>
					</div>
					<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
						<CustomizedTextField
							id="creator"
							label={"Créateur"}
							className="full_size light-disabled"
							disabled={noteDisabled}
							value={this.props.editingNote.create_uid.name}
						/>
					</div>
					<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
						<DatePicker
							label="Date de création"
							emptyLabel="La date est invalide"
							invalidDateMessage="La date est invalide"
							invalidLabel="La date est invalide"
							format="DD/MM/YYYY"
							onOpen={() => {}}
							open={false}
							className="col-lg-12 col-md-12 col-sm-12 col-12 light-disabled"
							value={this.props.editingNote.create_date}
							disabled={noteDisabled}
							id="create-date"
						/>
					</div>
					<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
						<DatePicker
							emptyLabel="La date est invalide"
							invalidDateMessage="La date est invalide"
							invalidLabel="La date est invalide"
							format="DD/MM/YYYY"
							label="Date de limite d'exécution"
							className="col-lg-12 col-md-12 col-sm-12 col-12"
							id="limit-date"
							value={this.props.editingNote.date_deadline}
							disabled={noteDisabled || !canUpdateDateDeadline}
							onChange={this.onUpdateLimitDate.bind(this)}
						/>
					</div>
					<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
						<FormControl className="row">
							<InputLabel id="status-label">Statut</InputLabel>
							<CustomizedSelect
								labelId="status-label"
								id="status"
								label={"Statut"}
								inputProps={{ name: "status", id: "status" }}
								placeholder={"Statut"}
								className={"full_size " + (!this.props.editingNote.creating ? "light-disabled" : "")}
								onChange={this.onStatusChange.bind(this)}
								value={this.state.stateRows.length > 0 ? this.props.editingNote.state : ""}
								disabled={noteDisabled}
							>
								{this.state.stateRows}
							</CustomizedSelect>
						</FormControl>
					</div>
					<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
						<FormControl className="row">
							<InputLabel id="tag-label">Etiquettes</InputLabel>
							<CustomizedSelect
								labelId="tag-label"
								id="tag"
								label={"Etiquettes"}
								inputProps={{ name: "tag", id: "tag" }}
								placeholder={"Etiquettes"}
								className=" full_size"
								value={this.state.tagRows.length > 0 ? this.props.editingNote.category_ids : ""}
								multiple
								open={this.state.tagsSelectOpen}
								onChange={this.onTagsChange.bind(this)}
								onOpen={this.openSelect.bind(this)}
								onClose={this.closeSelect.bind(this)}
								disabled={noteDisabled}
							>
								{this.state.tagRows}
							</CustomizedSelect>
						</FormControl>
					</div>
					<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top row">
						<div className="col-lg-10 col-md-10 col-sm-10 col-9 without-side-padding">
							<CustomizedTextField
								value={this.props.editingNote.plan?.name}
								id="plan"
								label="Plan"
								className="full_size light-disabled control-margin-top light-disabled"
							/>
						</div>
						{this.props.editingNote.plan ? (
							<div className="without-side-padding col-lg-2 col-md-2 col-sm-2 col-3 control-inline-btn">
								<Button
									className="div-center"
									variant="contained"
									size="small"
									disabled={noteDisabled}
									onClick={this.onPlanClick.bind(this)}
								>
									<MapIcon />
								</Button>
							</div>
						) : null}
					</div>
					<div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
						<TableWithoutPagination
							ref={this.table}
							data={this.props.editingNote.document_ids.filter((d) => !d.deleted)}
							columns={this.state.columns}
							minRows={5}
							contentEditable
							disabled={noteDisabled}
							getTrProps={(state, rowInfo) => {
								if (rowInfo && rowInfo.original.id === 0 && !rowInfo.original.deleted) {
									return {
										style: {
											background: "#E3F2FD",
										},
									};
								} else {
									return {};
								}
							}}
						/>
					</div>
				</div>
				{this.props.editingNote.id ? (
					<DialogActions>
						{canCancelNote(this.props.editingNote, this.props.activeUser, this.props.siteMonitoring) ? (
							<Button onClick={this.cancelNote.bind(this)} className="button red-button">
								<Icon>cancel</Icon>Annuler
							</Button>
						) : null}
						{canTerminateNote(this.props.editingNote, this.props.siteMonitoring, this.props.activeUser) ? (
							<Button onClick={this.terminateNote.bind(this)} className="button green-button">
								Terminer
							</Button>
						) : null}
						{canConfirmNote(this.props.editingNote, this.props.siteMonitoring, this.props.activeUser) ? (
							<Button onClick={this.confirmNote.bind(this)} className="button green-button">
								Confirmer
							</Button>
						) : null}
						{canRelaunchNote(this.props.editingNote, this.props.siteMonitoring, this.props.activeUser) ? (
							<Button onClick={this.relaunchNote.bind(this)} className="button red-button">
								Remettre en cours
							</Button>
						) : null}
						{canHistorizeNote(this.props.editingNote, this.props.siteMonitoring, this.props.activeUser) ? (
							<Button onClick={this.historizeNote.bind(this)} className="button green-button">
								Archiver
							</Button>
						) : null}
					</DialogActions>
				) : null}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		siteMonitoring: state.siteMonitoring.currentSiteMonitoring,
		notesFilters: state.notes.notesFilters,
		activeUser: state.activeUser,
		customerFound: state.tiers.customerSearch,
		lots: state.siteMonitoring.lots,
		tags: state.tags.allTags,
		editingNote: state.notes.editingNote,
		allUsers: state.users.allUsers,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		customerSearch: (code, user) => dispatch(customerSearch(code, user)),
		clearCustomerSearch: () => dispatch(clearCustomerSearch()),
		setEditingNote: (note) => dispatch(setEditingNote(note)),
		cancelNote: (note, siteMonitoring, filter, user) => dispatch(cancelNote(note, siteMonitoring, filter, user)),
		terminateNote: (note, siteMonitoring, filter, user) =>
			dispatch(terminateNote(note, siteMonitoring, filter, user)),
		confirmNote: (note, siteMonitoring, filter, user) => dispatch(confirmNote(note, siteMonitoring, filter, user)),
		relaunchNote: (note, siteMonitoring, filter, user) =>
			dispatch(relaunchNote(note, siteMonitoring, filter, user)),
		historizeNote: (note, siteMonitoring, filter, user) =>
			dispatch(historizeNote(note, siteMonitoring, filter, user)),
		throwErrorMessage: (errorObject) => dispatch(throwErrorMessage(errorObject)),
		loadPlan: (plan) => dispatch(loadPlan(plan)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailsTab);
